<script lang="ts">
  import { defineComponent } from "vue";
  import FicheTransactionEtablissement from '@/generated/fiches/FicheTransactionEtablissement.vue';
  export default defineComponent({
    extends: FicheTransactionEtablissement,
    components: {}
})
</script>
